import { GTMBaseParams } from '../lib/types';

interface GtmScriptProps {
  gtmId: string;
  baseParams: GTMBaseParams;
}

export function GtmScript({ gtmId, baseParams }: GtmScriptProps) {
  if (!gtmId) return null;

  const baseParamsJson = JSON.stringify(baseParams);
  const gtmIdJson = JSON.stringify(gtmId);

  const html = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(${baseParamsJson});w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',${gtmIdJson});`;

  return <script dangerouslySetInnerHTML={{ __html: html }} />;
}
